import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Flex, Button, Tooltip } from 'antd'
import { RollbackOutlined } from '@ant-design/icons'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { resetGoBackToVehicleTest } from '../actions/go-to-vehicle-test'
import { useIntl } from 'react-intl'
import { useEffect } from 'react'

const BackToTestSessionButton = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const allowedPathnames = [
    '/functional-diagrams/vin/',
    '/global-search/vin/',
    '/tracer/',
    '/functional-diagrams/component-detail',
  ]

  const goBackToVehicleTest = useSelector(
    (state) => state.goBackToVehicleTest,
    shallowEqual,
  )
  const back = () => {
    dispatch(resetGoBackToVehicleTest())
    history.push({
      pathname: goBackToVehicleTest.pathname,
    })
  }

  React.useEffect(() => {
    if (
      !allowedPathnames.find((allowed) => location.pathname.includes(allowed))
    ) {
      dispatch(resetGoBackToVehicleTest())
    }
  }, [location.pathname])

  return goBackToVehicleTest.pathname ? (
    <Flex gap="small" align="center">
      <Tooltip
        title={intl.formatMessage(
          {
            id: 'backToVehicleTestButton.tooltip.title',
          },
          {
            vin: goBackToVehicleTest.vin,
          },
        )}
      >
        <Button
          size="large"
          icon={<RollbackOutlined />}
          onClick={back}
          data-testid="back-to-vehicle-test-button"
        />
      </Tooltip>
    </Flex>
  ) : null
}

export default BackToTestSessionButton
